import React, { useState } from 'react';
import { connect } from 'react-redux';
import EvvCreateOptions from '../../../Admin/EVVContainer/EvvCreateModal/EvvCreateOptions';
import { AddMemberStyle } from '../../Teams/TeamSettings/Members';
import EvvCreateModal from '../../../Admin/EVVContainer/EvvCreateModal/EvvCreateModal';
import BulkModal from './BulkModal';
import { getTeamIdFromURL } from '../../../../_helpers';
import CreateClient from '../../../Admin/EVVContainer/Client/CreateClient';
const bulkCategory = 'client';

const Client = ({ provider, onCreateOrUpdate = () => {} }) => {
    const teamId = getTeamIdFromURL();
    const [showModal, setShowModal] = useState(false);
    const [createMode, setCreateMode] = useState(null);

    const handleModalShow = () => {
        setCreateMode(null);
        setShowModal(true);
    };
    const handleCloseAllModal = () => {
        setShowModal(false);
    };

    const handleGoBack = () => {
        setCreateMode(null);
    };

    let content = null;
    switch (createMode) {
        default:
            content = (
                <EvvCreateOptions type={bulkCategory} setCreateProviderMode={setCreateMode} fileType="excel (.xlsx)" />
            );
            break;
    }

    return (
        <>
            <div css={AddMemberStyle}>
                <button type="button" className="btn button-green" onClick={handleModalShow}>
                    Add Client
                </button>
            </div>
            {showModal && !createMode && (
                <EvvCreateModal
                    type={bulkCategory}
                    showModal={showModal}
                    hideModal={handleCloseAllModal}
                    content={content}
                    goBack={createMode ? handleGoBack : null}
                />
            )}
            {createMode === 'individual' && (
                <CreateClient
                    hideModal={handleCloseAllModal}
                    show={showModal}
                    setShow={setShowModal}
                    teamId={teamId}
                    onCreateOrUpdate={onCreateOrUpdate}
                    provider={provider}
                />
            )}
            {createMode === 'bulk' && (
                <BulkModal
                    bulkCategory={bulkCategory}
                    hideModal={handleCloseAllModal}
                    show={showModal}
                    setShow={setShowModal}
                    onCreateOrUpdate={onCreateOrUpdate}
                    provider={provider}
                />
            )}
        </>
    );
};

export default connect(null, {})(Client);
